import { useTheme } from '@emotion/react';
import { isThemeToken } from '@nettbureau/theme';
import { useMemo } from 'react';

/**
 * The multiplier to apply to the icon size relative to the text size. We do this to make icons
 * stand out more when used inline with text.
 */ const iconSizeMultiplier = 1.1;
/**
 * Hook that returns the size of the icon.
 *
 * @param size - The size of the icon.
 */ function useIconSize(size) {
    const theme = useTheme();
    return useMemo(()=>{
        return !size ? `${iconSizeMultiplier}em` : isThemeToken(size, theme.fontSizes) ? `calc(${theme.fontSizes[size]} * ${iconSizeMultiplier})` : size;
    }, [
        size,
        theme
    ]);
}

export { useIconSize };
//# sourceMappingURL=use-icon-size.js.map
